import { useTranslation } from "react-i18next";
import PageHeader from "../../components/common/pageheader/PageHeader";

const LessonPanelPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader title={t("pages.lessons.title")} />
      <p>{t("pages.lessons.description")}</p>
    </div>
  );
};

export default LessonPanelPage;
